import React from "react";

const ProgressBar = ({ progress }) => {
  return (
    <div className="flex items-center">
      <div className="relative w-full h-2 bg-accents rounded-full">
        <div
          className="h-2 bg-secondary rounded-full transition-all shim"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
